import { render, staticRenderFns } from "./UploadImage.vue?vue&type=template&id=6bd70674&scoped=true"
import script from "./UploadImage.vue?vue&type=script&lang=ts"
export * from "./UploadImage.vue?vue&type=script&lang=ts"
import style0 from "./UploadImage.vue?vue&type=style&index=0&id=6bd70674&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd70674",
  null
  
)

export default component.exports